import Drift from 'drift-zoom';

export default function() {
  /* eslint-disable no-new */
  new Drift(document.querySelector('.js-image-zoom'), {
    paneContainer: document.querySelector('.js-image-details'),
    sourceAttribute: 'src',
    zoomFactor: 2,
  });
}
